import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductImage from "../common/product/product-image";
import UpsellPopup from "./upsell-popup";
import {
  addStockNotification,
  removeStockNotification
} from '../../actions/stock-notifications';
import OrderingControls from "./card/ordering-controls";
import { addReplacementProduct } from "../../actions/orders";
import QuantityControls from './card/quantity-controls';

import './styles.css';
import './card.css';

class Card extends Component {
  state = {
    showUpsellPopup: false
  };

  constructor(props) {
    super(props);

    this.state = {
      labels: {},
      status: '',
      product_qty: 0,
      confirm: false,
      confirmedProduct: null,
      addPending: false,
      mouseEnter: false,
      cardClicked: false,
      notify_stock_check: this.props.hasStockNotification,
      quantity_counter: 0,
      showReplacementProduct: true
    };
  }

  setLabel() {
    const attr = this.props.product.attributes;

    this.setState({
      labels: {
        featured: attr.special_featured,
        reward: attr.special_reward,
        new: attr.special_new,
        missingFromAudit: this.props.missingFromAudit,
        game: this.props.game,
        inBasket: false,
        stockStatus: attr.stock_status,
        expectedStockDate: attr.expected_stock_date
      }
    }, this.setProductStatus);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.missingFromAudit !== prevProps.missingFromAudit) {
      this.setLabel();
    }

    if (this.props.basket[this.props.product.id] !== prevProps.basket[this.props.product.id]) {
      this.setState({
        quantity_counter: this.props.basket[this.props.product.id] ? this.props.basket[this.props.product.id].product_qty : 0
      }, this.setProductStatus);
    }

    if (this.props.basket[this.props.product.attributes.replacement_product.id] !== prevProps.basket[this.props.product.attributes.replacement_product.id]) {
      if (Object.keys(this.props.product.attributes.replacement_product).length > 0) {
        if (this.props.basket[this.props.product.attributes.replacement_product.id]) {
          this.setState({
            showReplacementProduct: this.props.basket[this.props.product.attributes.replacement_product.id].product_qty < this.props.products[this.props.product.attributes.replacement_product.id].attributes.max_per_order
          })
        } else {
          this.setState({
            showReplacementProduct: true
          })
        }
      }
    }
  }

  componentDidMount() {
    this.setLabel();

    if (this.props.basket[this.props.product.id]) {
      this.setState({
        quantity_counter: this.props.basket[this.props.product.id].product_qty
      })
    }

    if (Object.keys(this.props.product.attributes.replacement_product).length > 0) {
      if (this.props.basket[this.props.product.attributes.replacement_product.id]) {
        this.setState({
          showReplacementProduct: this.props.basket[this.props.product.attributes.replacement_product.id].product_qty < this.props.products[this.props.product.attributes.replacement_product.id].attributes.max_per_order
        })
      }
    }
  }

  setProductStatus() {
    if (this.props.productInBasket) {
      this.setState({
        labels: {
          ...this.state.labels,
          inBasket: true
        },
        status: 'in-basket'
      });
    } else {
      this.setState({
        labels: {
          ...this.state.labels,
          inBasket: false
        },
        status: ''
      });
    }
  }

  upsellPopupToggle = () => {
    this.setState({ showUpsellPopup: !this.state.showUpsellPopup });
  }

  upsellPopupClose = () => {
    this.setState({ showUpsellPopup: false });
  };

  handleToggleNotification = () => {
    this.setState({
      notify_stock_check: !this.state.notify_stock_check
    }, () => {
      if (this.state.notify_stock_check) {
        this.toggleStockNotification()
      }
    })
  }

  toggleStockNotification = () => {
    const { product: { id }, dispatch } = this.props;

    dispatch(
      this.state.notify_stock_check ? addStockNotification(id) : removeStockNotification(id)
    );
  }

  toggleLines = (event) => {
    const { dispatch } = this.props;

    dispatch({ type: 'TOGGLE_PRODUCT_CARD_TITLE' });
  };

  replacementProduct = () => {
    const { product, replacementProduct } = this.props;

    this.props.dispatch(addReplacementProduct(product, replacementProduct));
  }

  renderButton = () => {
    if (this.props.repairedProduct) {
      if (this.props.repairedProduct.id == this.props.product.id) {
        return <div className="card-button black">Items to review<div className="items-to-review-button" /></div>
      }
    }

    if (Object.keys(this.props.product.attributes.replacement_product).length > 0) {
      if (this.props.basket[this.props.product.attributes.replacement_product.id]) {
        if (this.props.basket[this.props.product.attributes.replacement_product.id].product_qty < this.props.products[this.props.product.attributes.replacement_product.id].attributes.max_per_order) {
          if (this.state.mouseEnter) {
            return <div className="card-button green clickable" onClick={() => this.replacementProduct()}>Add replacement</div>
          } else {
            return <div className="card-button red">Replace with alternative</div>
          }
        }
      } else {
        if (this.state.mouseEnter) {
          return <div className="card-button green clickable" onClick={() => this.replacementProduct()}>Add replacement</div>
        } else {
          return <div className="card-button red">Replace with alternative</div>
        }
      }
    }

    if (this.props.product.attributes.stock_status === 'Discontinued') {
      return <div className="card-button red">Discontinued</div>
    } else if (this.props.product.attributes.stock_status === 'Out of Stock') {
      return <div className="card-button red">Out of Stock</div>
    } else if (this.props.newOrderingEnabled && this.props.availableToOrder) {
      return <OrderingControls
        setQuantityCounter={this.setQuantityCounter}
        quantity={this.state.quantity_counter}
        product={this.props.product}
        handleConfirmation={this.props.handleConfirmation}
        upsellToggle={this.upsellPopupToggle}
        new_order_page={this.props.new_order_page}
        status={this.state.status}
      />
    } else {
      return <div className="card-button gray">Ordering Unavailable</div>
    }
  }

  onMouseEnterCard = () => {
    this.setState({
      mouseEnter: true,
    })
  }

  onCardClicked = () => {
    this.setState({
      cardClicked: true,
    })
  }

  onMouseLeaveCard = () => {
    this.setState({
      mouseEnter: false,
      cardClicked: false
    })
  }

  setQuantityCounter = (max_amount) => {
    this.setState({
      quantity_counter: Number(max_amount)
    })
  }

  handleQuantityInput = (e) => {
    e.preventDefault();
    if (Number(e.target.value)) {
      this.setState({
        quantity_counter: Number(e.target.value)
      })
    }
  }

  handleQuantityCount = (dir) => {
    if (dir === 'pos' && !Number(this.state.quantity_counter)) {
      this.setState({
        quantity_counter: Number(1)
      })
    } else if (dir === 'pos') {
      if (!Number.isInteger(this.state.quantity_counter)) {
        this.setState({
          quantity_counter: Number(1)
        })
      } else {
        this.setState({
          quantity_counter: Number(this.state.quantity_counter) + Number(1)
        })
      }
    } else if (dir === 'neg') {
      if (this.state.quantity_counter > 0) {
        this.setState({
          quantity_counter: Number(this.state.quantity_counter) - Number(1)
        })
      }
    }
  }

  formatPrice = (number) => {
    return Number.isInteger(number) ? number : number.toFixed(2)
  }

  promotionPrice = (outerPrice, promotionOuterPrice) => {
    return (
      <div>
        {`(€${this.formatPrice(outerPrice)})`}
        <br />
        {`€${this.formatPrice(promotionOuterPrice)}`}
      </div>
    );
  }

  render() {
    const {
      product, stockNotificationsEnabled, isTobacco, disableStockNotification
    } = this.props;
    const image = product.attributes.links ? product.attributes.links.image : product.attributes.image;
    const upsell_popup = product.attributes.upsell_popup;
    const { showUpsellPopup } = this.state;
    const isPromotionAvailable = Object.keys(product.attributes['promotion']).length !== 0;

    return (
      <div
        className={this.state.status == 'in-basket' ? 'product-card product-card-gray' : 'product-card product-card-gray-light'}
        onClick={() => this.onCardClicked()}
        onMouseEnter={() => this.onMouseEnterCard()}
        onMouseLeave={() => this.onMouseLeaveCard()}
      >
        <ProductImage
          labels={this.state.labels}
          image={image}
          productState={this.state.status}
          isTobacco={isTobacco}
        />
        {isTobacco && <div className='product-details-container'>
          <h4>
            {product.attributes.name}
          </h4>
        </div>}
        <div className="card-button-container">
          {this.renderButton()}
        </div>
        {(this.state.mouseEnter || this.state.cardClicked || showUpsellPopup) && (
          product.attributes.stock_status == 'Out of Stock' || product.attributes.stock_status == 'Discontinued' ? (
            <div className="card-overlay">
              {product.attributes.stock_status == 'Out of Stock' && (
                <div className="restock-info">
                  {product.attributes.expected_stock_date ? (
                    <p className="back-in-stock">This item is expected back in stock on {product.attributes.expected_stock_date}</p>
                  ) : (
                    <p className="back-in-stock">Expected back in stock date unknown</p>
                  )}
                  {stockNotificationsEnabled && (
                    <div className="notify-stock" onClick={() => this.handleToggleNotification()}>
                      <input className="notify-stock-check" type="checkbox" name="notify-stock" checked={this.state.notify_stock_check} disabled={disableStockNotification} /><span className="notify-checkmark"></span>
                      <p>Notify me when back in stock</p>
                    </div>
                  )}
                </div>
              )}
              {(Object.keys(product.attributes.replacement_product).length > 0 && this.state.showReplacementProduct) && (
                <div className="card-replacement-product-container">
                  <div className="replacement-product-top-container">
                    <div className="replacement-product-image-container">
                      <img src={product.attributes.replacement_product.image} alt={product.attributes.replacement_product.name} />
                    </div>
                    <p className="replacement-product-heading">
                      THIS REPLACEMENT IS AVAILABLE TO ADD TO YOUR BASKET
                </p>
                  </div>
                  <p className="replacement-product-name">
                    {product.attributes.replacement_product.name}
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="card-overlay">
              <QuantityControls
                handleQuantityCount={this.handleQuantityCount}
                handleQuantityInput={this.handleQuantityInput}
                quantity_counter={this.state.quantity_counter} />
              <div className="details-container">
                <div className="details">
                  <div className="item">
                    <h5>RSP</h5>
                    <p>€{this.formatPrice(product.attributes.rsp)}</p>
                  </div>
                  <div className="item">
                    <h5>Units per Outer</h5>
                    <p>{product.attributes['units_per_outer']}</p>
                  </div>
                  <div className="item">
                    <h5>Outer Price</h5>
                    <p>
                      {isPromotionAvailable ?
                        this.promotionPrice(product.attributes['outer_price'], product.attributes['promotion']['outer-price']) :
                        `€${this.formatPrice(product.attributes['outer_price'])}`}
                    </p>
                  </div>
                </div>
                <p className="details-product-wording">
                  {product.attributes.wording}
                </p>
              </div>
              {showUpsellPopup && <UpsellPopup upsell_popup={upsell_popup} onClose={this.upsellPopupClose} />}
            </div>
          ))}
      </div>
    )
  }
}

const DISABLED_STATES = ['updatePending', 'getPending'];
const mapStateToProps = ({
  orders: {
    new: newOrder,
    new: {
      products,
      basket: { line_items },
      repairedProduct
    },
    expandTitle,
  },
  stockNotifications: { productIds, currentState },
  features
}, {
  product,
  product: {
    attributes: {
      replacement_product: {
        id: replacementProductId
      }
    },
    id: productId
  }
}) => {
  const replacementProduct = products[replacementProductId] ? products[replacementProductId] : {}
  return ({
    product,
    products,
    basket: newOrder.basket.line_items,
    expandTitle: newOrder.expandTitle,
    availableToOrder: !['Out of Stock', 'Discontinued'].includes(product.attributes.stock_status),
    productInBasket: !!line_items[product.id],
    stockNotificationsEnabled: features.stock_notifications,
    hasStockNotification: productIds.includes(String(productId)),
    disableStockNotification: DISABLED_STATES.includes(currentState),
    newOrderingEnabled: features.new_ordering,
    replacementProduct,
    hasReplacementProduct: Object.keys(replacementProduct).length > 0,
    repairedProduct: repairedProduct
  })
}

export default connect(mapStateToProps)(Card);



// WEBPACK FOOTER //
// ./src/components/new-order/card.jsx